<script>
		import {docs, protoSkills, protoDomains, fetch_documentation} from "../core.js";
		import { marked } from "marked"
		import {onMount} from "svelte";
		import Collapsible from "../elements/Collapsible.svelte";
		import Select from "../elements/Select.svelte";
		import Domains from "./Domains.svelte";
		import SkillCard from "../elements/SkillCard.svelte";

		let viewTopic = $state(null)
		let viewSkill = $state(null)
		let viewDomain = $state(null)
		let viewEntry = $derived(docs?.find(entry => entry.topic === viewTopic || entry.title === viewTopic) ?? viewTopic)
		let viewDocs = $derived(docs?.filter((doc) => doc.chapter === viewEntry?.chapter && doc.section === viewEntry?.section))

		$effect( () => {
				document.getElementById(viewTopic)?.scrollIntoView()
		})

		let domain = $state(null)
		let struct = $state({})
		const chapters =
				[	{ID: 'intro', title: "Einführung"},
					{ID: 'hero', 	title: "Helden"},
					{ID: 'abils', title: "Fähigkeiten"},
					{ID: 'advt', 	title: "Abenteuer"},
					{ID: 'fshp', 	title: "Gemeinschaften"},
					{ID: 'play', 	title: "Im Spiel"},]
		const groups = ['chapter', 'section']

		// $inspect(`RULES - show information on ${$state.snapshot(viewTopic)}`, viewSkill)

		onMount(async () => {
			const docs = await fetch_documentation()
			docs.forEach(function (a) {
				groups.reduce(function (o, g, i) {                            // take existing object,
						o[a[g]] = o[a[g]] || (i + 1 === groups.length ? [] : {}); // or generate new obj, or
						return o[a[g]];                                           // at last, then an array
				}, struct).push(a);
			});
			console.log(`RULES - Documentation loaded: `, groups)
		})

		const categories = ['Kampf', 'Kampfstil', 'Waffen', 'Astral', 'Elementar', 'Vital', 'Kreatur']
		let groupedDomains =
			Object.groupBy(
				Object.values(protoDomains)
				.sort((a,b) => a.name.localeCompare(b.name))
			, ({category}) => category)

		let domainOptions =
			Object.fromEntries(
				categories
					.map(cat => [cat, groupedDomains[cat]]) )

		let groupedSkills =
			Object.groupBy(
				Object.values(protoSkills)
				.filter(skill => skill.cost >= 50)
				.sort((a,b) => a.name.localeCompare(b.name))
			, ({category}) => category)

		let skillOptions =
			Object.fromEntries(
				Object.keys(groupedSkills)
					.map(cat => [cat, groupedSkills[cat]]) )

		function show_skill(e) {
				viewTopic = null
				viewDomain = null
				viewSkill = protoSkills[e.target.value] ?? null
				// console.log(`RULES: Show domain ${viewDomain}`)
		}

		function show_domain(e) {
				viewTopic = null
				viewSkill = null
				viewDomain = e.target.value
				// console.log(`RULES: Show domain ${viewDomain}`)
		}


</script>

<!-------------------------------- HTML -------------------------------------->
<!-- Rules Screen has
        * introductory page  [no panel]
        * tutorial

    Rules view has
        * section on Pentelion rules  [panel has table of contents]
        * overview of all powers  [panel has navigation structure with domains]
 -->

<section id={view.layout.page}>
	<header>
		<h1>Dokumentation</h1>
	</header>

	<aside class="panel" data-help="toc">

		{#each Object.keys(struct) as chapID}
			{@const chapter = chapters.find(chap => chap.ID === chapID)?.title ?? chapID}
			<Collapsible header={chapter}>
				{#each Object.keys(struct[chapID]) as section}
					<Collapsible header={section} tag="h3">
						<ul class="topics">
							{#each struct[chapID][section] as entry}
								<li onclick={() => viewTopic = entry.topic}>{entry.title}</li>
							{/each}
						</ul>
					</Collapsible>
				{/each}
			</Collapsible>
		{/each}

		<Collapsible header="Tabellen">
			<Collapsible header="Fertigkeiten" tag=h3>
				<div class="select">
					<Select field='skill' bind:value={domain} options={skillOptions} separate onchange={show_skill} />
				</div>
			</Collapsible>

			<Collapsible header="Kräfte" tag=h3>
				<Select field='domain' bind:value={domain} options={domainOptions} separate onchange={show_domain}/>
			</Collapsible>
			<ul>
				<li>Übersicht Effekte</li>
				<li>Erfolgswürfe</li>
			</ul>
		</Collapsible>

	</aside>

	<article>
		{#if viewEntry}
			<h1>Regelbuch</h1>
			<h2>{viewEntry.chapter}</h2>
			{#each viewDocs as doc}
				<h3 id={doc.topic}>{doc.title}</h3>
				{@html marked(doc.text)}
			{/each}
		{:else if viewSkill}
			<h2>Fertigkeiten</h2>
			<SkillCard skill={viewSkill}/>
		{:else if viewDomain}
			<Domains domainID={viewDomain}/>
		{/if}


	</article>
</section>


<style lang="sass">
	#rules
		--panel-width: 300px
		display: grid
		grid-template-columns: var(--panel-width) auto
		grid-template-rows: 102px auto fit-content(30px)
		grid-template-areas: "... head"   "panel main"   "... foot"

	section
		height: 100%
		overflow: auto
		font-size: large

	:global(h3)
		margin: 0.5em 1em

	:global(h4)
		margin: 0.2em 2em

	.topics
		margin: 0 3em

	.select
		padding-left: 2em
</style>